"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADING_TYPES = void 0;
var HEADING_TYPES = Object.freeze({
  0: 'h0',
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6'
});
exports.HEADING_TYPES = HEADING_TYPES;